// extracted by mini-css-extract-plugin
export default {"wrapper":"PPCCompliancePage_wrapper__fGGmi"};